module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Aktuelles Guthaben","flags":["TRACK"],"track":"Current Balance"}}